import React from 'react';
import { Typography, Box } from '@mui/material';
import { useStyles } from './styles';

const BiColorHeader = ({ left, right }) => {
    const classes = useStyles();
    return (
        <Box sx={{ display: 'flex' }}>
            <Typography
                variant="h1"
                className={classes.biColorHeader}
            >
                {left}
            </Typography>
            <Typography
                variant="h1"
                className={classes.biColorHeader}
            >
                &nbsp;
            </Typography>
            <Typography
                variant="h1"
                className={classes.headerSpan}
            >
                {right}
            </Typography>
        </Box>
    );
};
export default BiColorHeader;
